import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          theme="light"
          toastOptions={{
            style: {
              background: "#FAF9F6",
              color: "#1A2F3B",
              border: "1px solid #E5DFD3",
              borderRadius: "2px",
              fontFamily: "Outfit, sans-serif",
              letterSpacing: "0.02em",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
